@if (everythingReady && hasCompany()) {
  <div class="grid">
    <a [routerLink]="['/home']" class="col-12">
      <div class="profile-initials mr-4 ml-4" >{{userIntials}}</div>
    </a>
    <div class="col-12 ml-3 mr-1">
      <ul class="list-unstyled">
        <li><span class="far fa-user mr-1 icon-width"></span> {{user.firstName}} {{user.lastName}}</li>
        <li class="flex align-items-center">
          <span class="far fa-building mr-1 icon-width"></span>
          @if (!isCompanyDropdownOpen) {
            <div class="flex align-items-center">
              <span class="company-name">{{selectedCompany?.companyName || 'No Companies Associated'}}</span>
              @if (availableCompanies.length > 1) {
                <i class="pi pi-arrow-right-arrow-left ml-2 company-edit-icon" (click)="toggleCompanyDropdown()" title="Change Company Context"></i>
              }
            </div>
          }
          @if (isCompanyDropdownOpen) {
            <p-select [options]="availableCompanies" placeholder="No Companies Associated"
              [(ngModel)]="selectedCompany" filter="true"
              (onChange)="selectedCompanyChanged()"
              (onHide)="toggleCompanyDropdown()"
              [showClear]="false"
              appendTo="body">
            </p-select>
          }
        </li>
        <li><span class="far fa-envelope mr-1 icon-width"></span> {{user.email}}</li>
        <li><span class="fa fa-mobile-alt mr-1 icon-width"></span> {{user.contactNumber}}</li>
      </ul>
    </div>
    <div class="col-12 ml-3 mr-1">
      <p-button label="Edit Profile" icon="pi pi-pencil" iconPos="left" (click)="editUserProfile()"></p-button>
    </div>
    <div class="col-12 ml-3 mr-1">
      <hr>
      </div>
      <div class="col-12 ml-3 mr-1">
        <ul class="list-unstyled">
          @if (isUserAdmin()) {
            <li><a [routerLink]="['/companies']" class="links">Manage Company</a></li>
          }
          @if (isUserAdmin()) {
            <li><a [routerLink]="['/users']" class="links">Manage Users</a></li>
          }
          @if (isUserAdmin() && (selectedCompanyIsVendor$ | async)) {
            <li><a [routerLink]="['/devices']" class="links">Manage Devices</a></li>
          }
          @if (user.isGlobalAdmin) {
            <li><a [routerLink]="['/device-diagnostics']" class="links">Device Diagnostics</a></li>
          }
          <li><a [routerLink]="['/jobs2']" class="links">Manage Jobs</a></li>
          @if (isUserAdmin()) {
            <li><a [routerLink]="['/job-integrations']" class="links">Job Integrations</a></li>
          }
          @if (isUserEditorOrAdmin() && jobSimulatorFeatureEnabled) {
            <li><a [routerLink]="['/simulator']" class="links">Job Simulator</a></li>
          }
          <!-- <li *ngIf="isUserAdmin()"><a [routerLink]="['/requests']" class="links">Manage Associations</a></li> -->
          @if (isUserSuperAdmin()) {
            <li><a [routerLink]="[]" class="links" (click)="getCompanyUserReport()" >Company & User Report</a></li>
          }
          <li ><a [routerLink]="['/files']" class="links" >Shared File Vault</a></li>
          @if (selectedCompany) {
            <li><a [routerLink]="['/company-files', selectedCompany.companyId]" class="links">{{selectedCompany.companyName}} File Vault</a></li>
          }
        </ul>
      </div>
      <!-- <div *ngIf="requestsCount" class="col-12 ml-3 mr-1 alert alert-success" role="alert">
      <h2>Authorizations</h2>
      <p>You have {{requestsCount}} pending approval.</p>
    </div> -->
  </div>
}

